/**
 * Which help view is open (2026-10-05). One modal, several views, so the
 * person never loses their place: an article links to another, "Report a
 * problem" sits one tap from any answer, and Back always goes back.
 */

import { createSignal } from 'solid-js';
import type { ReportType } from '../diag/opReport.ts';

export type HelpView =
  | { v: 'home' }
  | { v: 'article'; slug: string }
  | { v: 'report'; type?: ReportType; page?: string }
  | { v: 'reports' }
  | { v: 'report-detail'; id: string }
  | { v: 'whats-new' };

const [stack, setStack] = createSignal<HelpView[]>([]);

export const helpOpen = () => stack().length > 0;
export const helpView = () => stack()[stack().length - 1] ?? { v: 'home' as const };
export const helpCanGoBack = () => stack().length > 1;
/** The view Back returns to (for its label), or null at the bottom. */
export const helpPrevView = (): HelpView | null => { const s = stack(); return s.length > 1 ? s[s.length - 2]! : null; };

/** Open help at a view (home by default). Opening while open pushes. */
export function openHelp(view: HelpView = { v: 'home' }): void {
  setStack((s) => (s.length === 0 && view.v !== 'home' ? [{ v: 'home' }, view] : [...s, view]));
}
export function helpGo(view: HelpView): void { setStack((s) => [...s, view]); }
export function helpBack(): void { setStack((s) => (s.length > 1 ? s.slice(0, -1) : s)); }
export function closeHelp(): void { setStack([]); }
